import HeadlineForm from './HeadlineForm';
import LocationForm from './LocationForm';
import IndustryForm from './IndustryForm';
import SummaryForm from './SummaryForm';
import ExperienceForm from './ExperienceForm';
import EducationForm from './EducationForm';
import CertificateForm from './CertificateForm';
import PressForm from './PressForm';
import AwardForm from './AwardsForm';
import PublicationForm from './PublicationForm';
import ExternalEndorsementForm from './ExternalEndorsementForm';
import RequestEndorsement from './RequestEndorsement';

export {
    IndustryForm,
    HeadlineForm,
    LocationForm,
    SummaryForm,
    ExperienceForm,
    EducationForm,
    CertificateForm,
    PressForm,
    AwardForm,
    PublicationForm,
    ExternalEndorsementForm,
    RequestEndorsement,
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/forms.js